import { helpers } from 'vuelidate/lib/validators';
export default helpers.regex('isValidBicSwift', /^[A-Z]{6}[2-9A-Z]{1}[0-9A-NP-Z]{1}(([0-9A-WY-Z]{1}[0-9A-Z]{2})|(X{3})|)$/);
